export var Customer;
(function (Customer) {
    Customer["VIDA"] = "VIDATERMINO";
    Customer["LEY"] = "LEY";
    Customer["AUTO"] = "AUTO";
    Customer["FULL"] = "Full";
    Customer["AUTO_FULL"] = "Auto Full";
})(Customer || (Customer = {}));
